import { STORE_USER } from './types'

export function storeUser(user) {
    return {
        type: STORE_USER,
        payload: user,
    }
}
